import { Handle, Position } from "reactflow";
import { Draggable, Dropzone } from "../dragdrop";
import { InterpType } from "../../interpretation/interpretable";
import { useInterpretable } from "../flowchart";
import assert from "assert";
import { Shape } from "../shape";

export function AssignmentNode({ data }: { data: string }) {
  const [assignment, setData] = useInterpretable(data);

  if (!assignment) {
    // I believe a rerender is triggered when:
    // the internal assignment context map has changed,
    // the node's uuid has changed.
    // as such this is a problem as we have multiple rerenders. debugging needed to prevent this.
    console.log("assignment none?");
    return <></>;
  }

  assert(assignment.type == InterpType.Assignment);

  return (
    <Shape shapeType="round-rect" width={120} height={50} color="green">
      <Handle type="target" position={Position.Bottom} id={Position.Bottom}></Handle>
      <Handle type="target" position={Position.Top} id={Position.Top}></Handle>
      <Handle type="target" position={Position.Left} id={Position.Left}></Handle>
      <Handle type="target" position={Position.Right} id={Position.Right}></Handle>
      <Handle type="source" position={Position.Bottom} id={Position.Bottom}></Handle>
      <Handle type="source" position={Position.Top} id={Position.Top}></Handle>
      <Handle type="source" position={Position.Left} id={Position.Left}></Handle>
      <Handle type="source" position={Position.Right} id={Position.Right}></Handle>
      <div style={{ display: "flex", justifyContent: "left" }}>
        <Dropzone accepts={[InterpType.Identifier]} holds={assignment.children.left} />
        <span style={{marginRight: ".5em", marginLeft: ".5em"}}> = </span>
        <Dropzone accepts={[InterpType.Identifier]} holds={assignment.children.right} />
      </div>
    </Shape>
  );
}
